import script from "./Authenticator.vue?vue&type=script&setup=true&lang=js"
export * from "./Authenticator.vue?vue&type=script&setup=true&lang=js"

import "./Authenticator.vue?vue&type=style&index=0&id=3b1aa3e0&lang=css"

const __exports__ = script;

export default __exports__